import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CommonModal from "../components/Common/Modals/CommonModal";
import { Typography } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { closeCommonPageModal } from "../redux/action/utilActions";

import * as layouts from "./index";
const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      backgroundColor: "white",
    },
  },
}));

const ModalContainer = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { commonPageModalOpen, commonPageData } = useSelector(
    (state) => state.util
  );

  const onClose = () => {
    dispatch(closeCommonPageModal());
  };

  const renderComponent = () => {
    let Data = layouts[commonPageData?.link];
    return (
      <Data
        datalink={commonPageData?.datalink}
        postlink={commonPageData?.postlink}
      />
    );
  };
  return (
    <div className={classes.root}>
      <CommonModal
        open={commonPageModalOpen}
        onClose={onClose}
        title={commonPageData?.title || "title"}
        component={layouts[commonPageData?.link]}
      >
        {layouts[commonPageData?.link] && renderComponent()}
      </CommonModal>
    </div>
  );
};
export default ModalContainer;
